/**
 * Tela exibida quando o endereço não corresponde a nenhuma rota.
 *
 * O quê: informa que a página não existe e oferece a volta à tela inicial.
 *
 * Como: durante a migração esta tela também cobre um caso legítimo — alguém
 * guardou o link de um módulo que ainda não foi portado. Por isso o texto não
 * afirma que a página não existe, e sim que não foi encontrada neste endereço.
 *
 * Utiliza: react-router (Link).
 */
import { Link } from 'react-router';

/**
 * Renderiza a mensagem de rota não encontrada.
 *
 * @returns Bloco centralizado com explicação e link para a tela inicial.
 */
export function PaginaNaoEncontrada() {
  return (
    <div className="py-16 text-center">
      <p className="font-mono text-sm text-texto-fraco">404</p>
      <h1 className="mt-2 font-serif text-2xl text-foreground">Página não encontrada</h1>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
        Este endereço não corresponde a nenhuma tela. Se você chegou por um link antigo, o
        módulo pode ainda não ter sido migrado.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block text-sm text-primary underline underline-offset-4"
      >
        Voltar ao início
      </Link>
    </div>
  );
}
